import React, { Component } from 'react';
import styled from 'styled-components';
import { Row, Col, Select, Input, Button,Spin } from 'antd';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { getAllOperatorList,updateFulfilmentdetails,verifyBankAccount,fetchBankDetailsFromIfscCode} from '../../../services/api/offline-consult';
import { toast } from 'react-toastify';

const { Option } = Select;

const Text = styled.p`
  margin: 0;
  font-family: BrandonText-Medium, Lato, sans-serif;
`;

const SemiboldText = styled(Text)`
  font-family: ProximaNova-Semibold, Lato, sans-serif;
`;

const TitleText = styled(SemiboldText)`
  font-size: 1.5rem;
  text-align: center;
  color: #666569;
`;


const BodyContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 20px;
`;

const StyledInputBox = styled(Input)`
  font-size: 16px !important;
  background-color: #f8f8f8;
  border-radius: 10px !important;
  width: 100%;
  height: 40px;
  padding: 6px 12px;
  margin-bottom: 14px;
`;

const StyledSelect = styled(Select)`
  width: 100% !important;
  border-radius: 10px !important;
  height: 40px !important;
  margin-bottom: 14px;

  .ant-select-selector {
    height: 40px !important;
    display: flex;
    align-items: center;
    padding-left: 12px !important;
    border: 1px solid #d9d9d9 !important;
    border-radius: 10px !important;
    transition: border 0.3s ease;
    box-shadow: none !important;
  }

  &:hover .ant-select-selector {
    border-color: #4096ff !important; /* Same as Input hover border */
  }

  &.ant-select-focused .ant-select-selector {
    border-color: #4096ff !important; /* Same as Input focus border */
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important; /* Input-like focus ring */
  }

  .ant-select-selection-item {
    line-height: normal !important;
  }
`;





const LabelText = styled(SemiboldText)`
  font-size: 12px;
  margin-bottom: 4px;
  color: #7c7c7c;
`;

const ButtonRow = styled(Row)`
  margin-top: 20px;
`;

const FullWidthButton = styled(Button)`
  width: 100%;
  height: 44px;
  border-radius: 10px;
`;

const reasons = [
  "Pending verification for payment details",
  "Center not accepting patients due to outstanding payment",
  "TDS issue",
  "Others"
];

class FulfillmentModal extends Component {
  state = {
    vistSpocs: [],
    filterVistSpocs: [],
    isFilterVisitSpoc: false,
    centerId:'',
    requestId:'',
    verifyLoading:false,
    isIfscVerified : false,
    isAccountNumberVerified: false,
    ifscCodeVerifiedCheck:false,
    lastifsc:'',
    lastAccountNumber : '',
    isSaveLoading:false,
    formData: {
      preferredPayment: '',
      payeeName: '',
      accountNumber: '',
      accountType: '',
      ifscCode: '',
      bankName: '',
      branch: '',
      upiAddress: '',
      visitSpoc: '',
      tds: '',
      paymentCycle: '',
      remarks: '',
      fulfilmentDetailsUpdateReason: '',
      otherReason: '',
    },
  };

  async componentDidMount() {
    const operators = await getAllOperatorList();
    if (operators.success) {
      this.setState({
        vistSpocs: operators.data,
        filterVistSpocs: operators.data,
      });
    }
    const { closeFulfilmentModal } = this.props;
    const { paymentInfo,centerId,requestId } = this.props;
    if (paymentInfo) {
      this.setState({requestId:requestId});
      this.setState({centerId:centerId});
      this.setState(prev => ({
        formData: {
          ...prev.formData,
          ...(paymentInfo?.fulfilment)
        },
      }));
    }

    if(this.state.formData.accountNumber){
      this.setState({isAccountNumberVerified: true,lastAccountNumber:this.state.formData.accountNumber})  
    }

    if(this.state.formData.ifscCode){
      this.setState({ isIfscVerified : true,lastifsc:this.state.formData.ifscCode})
    }

    if(this.state.formData.preferredPayment && this.state.formData.preferredPayment.toLocaleLowerCase()=='upi'){
      this.setState({isAccountNumberVerified: true})
      this.setState({ isIfscVerified : true})
    }
    if (!this.state.formData.preferredPayment) {
      this.setState(prevState => ({
        formData: {
          ...prevState.formData,
          preferredPayment: 'Bank Account'
        }
      }));
    }
  }

  handleInputChange = (field, value) => {
   
    // if (field === 'visitSpoc') {
    //   this.setState({ isFilterVisitSpoc: false });
    // } 

    this.setState(prev => ({
      formData: {
        ...prev.formData,
        [field]: value,
      },
    }));

    if (field === 'ifscCode' && value.length == 11) {
      this.setState({ isIfscVerified: false });
    }

    if (field === 'accountNumber' && this.state.formData.accountNumber !== this.state.lastAccountNumber) {
      this.setState({ isAccountNumberVerified:false });
    }
  };


  handleSearch = (inputValue) => {
    this.setState({ isFilterVisitSpoc: true });

    if (!inputValue) {
      this.setState((prev) => ({
        filterVistSpocs: prev.vistSpocs,
        isFilterVisitSpoc: false,
      }));
    } else {
      const filteredList = this.state.vistSpocs.filter((spoc) =>
        spoc.name.toLowerCase().includes(inputValue.toLowerCase())
      );
      this.setState({ filterVistSpocs: filteredList });
    }
  };

  handleSave = async (handleFulfilmentDetailsSave) => {
    const { formData } = this.state;
  
    // Validate UPI address if preferred payment is UPI
    if(this.state.formData.preferredPayment && this.state.formData.preferredPayment.toLocaleLowerCase()=='upi' && !this.state.formData.upiAddress){
      toast.error("Enter upi address");
      return;
    }
    if(this.state.formData.preferredPayment && this.state.formData.preferredPayment.toLocaleLowerCase()=='upi' && !this.state.formData.upiAddress.includes('@')){
      toast.error("Enter valied upi address");
      return;
    }
    if (!formData.fulfilmentDetailsUpdateReason) {
      toast.error("Please select a reason before saving.");
      this.setState({ isSaveLoading: false });
      return;
    }
  
    this.setState({ isSaveLoading: true });
  
    try {

      const finalReason =
      formData.fulfilmentDetailsUpdateReason === "Others"
        ? `Others: ${formData.otherReason}`
        : formData.fulfilmentDetailsUpdateReason;

    const payload = {
      ...formData,
      fulfilmentDetailsUpdateReason: finalReason,
    };

      const updateDetails = await updateFulfilmentdetails(
        this.state.requestId,
        this.state.centerId,
        payload
      );
  
      console.log("Resolved updateDetails:", updateDetails);
  
      if (updateDetails.message?.toLowerCase() === 'success') {
        toast.success(
          `Request raised successfully. The request ID is ${updateDetails.data?.fulfilmentRequestId || 'N/A'}.`
        );
        handleFulfilmentDetailsSave()
      } else {
        toast.error("Something went wrong while saving the fulfilment details.");
      }
    } catch (error) {
      console.error("Error while saving fulfilment details:", error);
      toast.error("An error occurred while saving fulfilment details.");
    } finally {
      this.setState({ isSaveLoading: false });
    }
  };
  

  bankDetails = (e) => {
    const ifscCode = this.state.formData.ifscCode;
    fetchBankDetailsFromIfscCode(ifscCode)
      .then((res) => {
        const bankDetails = res.data;
        this.setState({ isIfscVerified: true});
        if(this.state.isAccountNumberVerified)
        {
          this.setState({ifscCodeVerifiedCheck:true,isAccountNumberVerified:false });
        }
        this.setState(prev => ({
          formData: {
            ...prev.formData,
            ['bankName']: bankDetails.BANK,
            ['branch']: bankDetails.BRANCH,
          },
        }));
      })
      .catch((err) => {
        console.log(err);
      });
    // }
  };


  handleBankVerification = async () => {
    try {
      const { accountNumber, ifscCode } = this.state.formData;
      this.setState({ verifyLoading: true });

      if (this.state.formData.accountNumber == this.state.lastAccountNumber && this.state.formData.ifscCode == this.state.lastifsc && this.state.isIfscVerified && (this.state.isAccountNumberVerified || this.state.ifscCodeVerifiedCheck)) {
        this.setState({ isAccountNumberVerified : true, verifyLoading: false,lastAccountNumber: accountNumber,lastifsc : ifscCode });
        toast.success('Bank details verified successfully');
        return;
      }
      const bankDetails = await verifyBankAccount(accountNumber, ifscCode);
      console.log(bankDetails);
      if (bankDetails.errsubCode !== '200') {
        this.setState({ validBankresponse: false });
      }
      if (bankDetails.message === 'success') {
        toast.success('Bank details verified successfully');
        this.setState({ isAccountNumberVerified : true, verifyLoading: false,lastAccountNumber: accountNumber,lastifsc : ifscCode });
        this.setState(prev => ({
          formData: {
            ...prev.formData,
            ['payeeName']: bankDetails.data.nameAtBank,
            ['bankName']: bankDetails.data.bankName,
            ['branch']: bankDetails.data.branch,
          },
        }));
      }
      if (bankDetails.errsubCode === '200') {
        this.setState({ validBankresponse: true });
      }
      this.setState({ verifyLoading: false });
    }
    catch (err) {
      console.log(err);
      this.setState({ verifyLoading: false });
    }
  }

  handleFulfilmentReasonChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      formData: {
        ...prev.formData,
        [name]: value,
        ...(name === "fulfilmentDetailsUpdateReason" && value !== "Others"
          ? { otherReason: "" }
          : {})
      }
    }));
  };


  render() {
    const { closeFulfilmentModal,handleFulfilmentDetailsSave } = this.props;
    const { formData, filterVistSpocs, vistSpocs, isFilterVisitSpoc } = this.state;
    const { fulfilmentDetailsUpdateReason, otherReason } = this.state.formData;

    const finalReason =
    fulfilmentDetailsUpdateReason === "Others"
      ? `Others: ${otherReason}`
      : fulfilmentDetailsUpdateReason;
    
    return (
      <Modal isOpen={true} backdrop="static">
        <ModalHeader toggle={() => closeFulfilmentModal()} style={{padding:'1rem 1rem'}}>Fulfillment Details</ModalHeader>
        <ModalBody>
          <Row gutter={[16, 16]} style={{rowGap:'0px'}}>
            <Col span={12}>
              <LabelText>Preferred Payment Mode</LabelText>
              <StyledSelect
                value={this.state.formData.preferredPayment}
                onChange={(value) => this.handleInputChange('preferredPayment', value)}
              >
                <Option value="Bank Account">Bank Account</Option>
                <Option value="UPI">UPI</Option>
              </StyledSelect>
            </Col>

            <Col span={12}>
              <LabelText>Payee Name</LabelText>
              <StyledInputBox
                value={formData.payeeName}
                onChange={(e) => this.handleInputChange('payeeName', e.target.value)}
                placeholder="Payee Name"
              />
            </Col>

            {this.state.formData.preferredPayment === 'Bank Account' && (
              <>
                <Col span={12}>
                  <LabelText>Account Number</LabelText>
                  <StyledInputBox
                    value={formData.accountNumber}
                    onChange={(e) => this.handleInputChange('accountNumber', e.target.value)}
                    placeholder="Account Number"
                  />
                </Col>
                <Col span={12}>
                  <LabelText>Account Type</LabelText>
                  <StyledInputBox
                    value={formData.accountType}
                    onChange={(e) => this.handleInputChange('accountType', e.target.value)}
                    placeholder="Account Type"
                  />
                </Col>
                <Col span={12}>
                  <LabelText>IFSC Code</LabelText>
                  <StyledInputBox
                    value={formData.ifscCode}
                    onChange={(e) => this.handleInputChange('ifscCode', e.target.value)}
                    placeholder="IFSC Code"
                    onBlur={this.bankDetails}
                  />
                  

                  <Button
                    type='primary'
                    style={{
                      marginTop: "5px",
                      borderRadius: "5px",
                      width: "80px", // fixed width to match "Verify"
                      opacity: this.state.isIfscVerified && this.state.isAccountNumberVerified ? 0.5 : 1,
                    }}
                    disabled={this.state.isIfscVerified && this.state.isAccountNumberVerified}
                    onClick={() => this.handleBankVerification()}
                  >
                    {this.state.verifyLoading ? <Spin size="small" /> : 'Verify'}
                  </Button>



                </Col>
                <Col span={12}>
                  <LabelText>Bank Name</LabelText>
                  <StyledInputBox
                    value={formData.bankName}
                    onChange={(e) => this.handleInputChange('bankName', e.target.value)}
                    placeholder="Bank Name"
                  />
                </Col>
                <Col span={12}>
                  <LabelText>Branch</LabelText>
                  <StyledInputBox
                    value={formData.branch}
                    onChange={(e) => this.handleInputChange('branch', e.target.value)}
                    placeholder="Branch"
                  />
                </Col>
              </>
            )}

            {this.state.formData.preferredPayment === 'UPI' && (
              <Col span={12}>
                <LabelText>UPI Address</LabelText>
                <StyledInputBox
                  value={formData.upiAddress}
                  onChange={(e) => this.handleInputChange('upiAddress', e.target.value)}
                  placeholder="UPI ID"
                />
              </Col>
            )}

            <Col span={12}>
              <LabelText>Payment Cycle</LabelText>
              <StyledSelect
                value={formData.paymentCycle}
                onChange={(value) => this.handleInputChange('paymentCycle', value)}
              >
                <Option value="before consultation">Before consultation</Option>
                <Option value="after consultation">After consultation</Option>
                <Option value="within 2">Within 2 days</Option>
                <Option value="within 7">Within 7 days</Option>
                <Option value="within 15">Within 15 days</Option>
                <Option value="30 Days">30 days</Option>
              </StyledSelect>
            </Col>

            {/* <Col span={12}>
              <LabelText>Visit Spoc</LabelText>
              <StyledSelect
                showSearch
                value={formData.visitSpoc}
                placeholder="Select or Search Visit Spoc"
                optionFilterProp="children"
                onSearch={this.handleSearch}
                onChange={(value) => this.handleInputChange('visitSpoc', value)}
                onDropdownVisibleChange={(open) => {
                  if (!open) {
                    this.setState((prev) => ({
                      filterVistSpocs: prev.vistSpocs,
                      isFilterVisitSpoc: false,
                    }));
                  }
                }}
              >
                {(isFilterVisitSpoc ? filterVistSpocs : filterVistSpocs.length > 0 ? vistSpocs : []).map(
                  (spoc) => (
                    <Option key={spoc.operatorId} value={spoc.operatorId}>
                      {spoc.name}
                    </Option>
                  )
                )}
              </StyledSelect>
            </Col> */}

            <Col span={12}>
              <LabelText>TDS Percentage</LabelText>
              <StyledInputBox
                value={formData.tds}
                onChange={(e) => this.handleInputChange('tds', e.target.value)}
                placeholder="TDS Percentage"
              />
            </Col>

            <Col>
              <LabelText>Any other query?</LabelText>
              <select
                name="fulfilmentDetailsUpdateReason"
                value={this.state.formData.fulfilmentDetailsUpdateReason}
                onChange={this.handleFulfilmentReasonChange}
                style={{ marginLeft: "10px", borderRadius: "8px", height: "35px", width: "274px", padding: "5px" }}
              >
                <option value="" disabled>
                  Select Reason
                </option>
                {reasons.map((r, i) => (
                  <option key={i} value={r}>
                    {r}
                  </option>
                ))}
              </select>

              {this.state.formData.fulfilmentDetailsUpdateReason === "Others" && (
                <input
                  type="text"
                  name="otherReason"
                  placeholder="Please specify the reason"
                  value={this.state.formData.otherReason}
                  onChange={this.handleFulfilmentReasonChange}
                  style={{ marginLeft: "10px", marginTop: "10px", borderRadius: "8px", height: "35px", width: "274px", padding: "5px" }}
                />
              )}
            </Col>
            <ButtonRow gutter={16} style={{ width: '100%' }}>
              <Col span={12}>
                <FullWidthButton onClick={closeFulfilmentModal} style={{borderRadius:'8px',height:"35px"}}>Cancel</FullWidthButton>
              </Col>
              <Col span={12}>
              <FullWidthButton
                  type="primary"
                  onClick={() => {
                    this.handleSave(handleFulfilmentDetailsSave);
                  }}
                  style={{
                    borderRadius: '8px',
                    height: "35px",
                    opacity:
                      this.state.isSaveLoading
                        ? 1 // Full opacity during loading
                        : this.state.isIfscVerified && this.state.isAccountNumberVerified
                          ? 1
                          : 0.5,
                    pointerEvents:
                      this.state.isSaveLoading ||
                      (this.state.isIfscVerified && this.state.isAccountNumberVerified)
                        ? 'auto'
                        : 'none', // Ensures click doesn't work when "disabled"
                  }}
                  disabled={
                    (!this.state.isIfscVerified && !this.state.isAccountNumberVerified ||
                    this.state.isSaveLoading) // allow button to be clickable (visibly disabled) if loading
                  }
                >
                  {this.state.isSaveLoading ? <Spin size="small" /> : 'Save'}
                </FullWidthButton>

              </Col>
            </ButtonRow>
          </Row>
        </ModalBody>
      </Modal>
    );
  }
}

export default FulfillmentModal;
